import cn from 'classnames'
import React, { ReactElement } from 'react'

import { BROWSER_COMPATIBILITY_VIEW_BG_IMAGE } from '../../constants/BrowserConstants'
import themes from '../../themes'

import * as Styles from './styles'

interface Props {
   appLogo: string

   logoClassName?: string
   containerClassName?: string
   headerContainerClassName?: string
   title: string
   description?: string
   infoImageURL: string
}

const BrowserNotCompatibleView = (props: Props): React.ReactElement => {
   const {
      appLogo,
      logoClassName,
      containerClassName,
      headerContainerClassName,
      infoImageURL,
      title,
      description
   } = props

   const colorTheme = themes.light.browserNotCompatibleView

   const renderHeader = (): ReactElement => (
      <div
         className={cn(Styles.headerContainerStyles, headerContainerClassName)}
      >
         <img
            src={appLogo}
            className={cn('h-[56px]', logoClassName)}
            alt='App Logo'
         />
      </div>
   )

   const renderTitleDescription = (): ReactElement => (
      <div className={Styles.titleDescriptionContainerStyles}>
         <p className={cn(Styles.titleStyles, colorTheme.titleColor)}>
            {title}
         </p>
         {description ? (
            <p
               className={cn(
                  Styles.descriptionStyles,
                  colorTheme.descriptionColor
               )}
            >
               {description}
            </p>
         ) : null}
      </div>
   )

   const renderViewDetails = (): ReactElement => (
      <div className={Styles.detailsContainerStyles}>
         <img src={infoImageURL} className={Styles.imageStyles} />

         {renderTitleDescription()}
      </div>
   )

   return (
      <div
         style={{
            backgroundImage: `url(${BROWSER_COMPATIBILITY_VIEW_BG_IMAGE})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover'
         }}
         className={cn(Styles.containerStyles, containerClassName)}
      >
         {renderHeader()}
         {renderViewDetails()}
      </div>
   )
}

export default BrowserNotCompatibleView
